import {apiFetch} from "./General";

export const getUIContent = (type, callback, errorCallback) => {

    apiFetch('uicontent?type=' + type, '', callback, errorCallback);
}
